import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Injury
export const addNearMiss = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/operations/app/v1/create-nearMiss`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log({ error })
    throw error
  }
}

// update Injury
export const updateNearMiss = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/operations/app/v1/update-nearMiss/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
// delete nearMiss 
export const deletenearMiss = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/operations/app/v1/delete-nearMiss/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// total count
export const countNearMiss = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/count-nearmiss`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Get nearmiss by ID
export const getlistByIdnearMiss = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/getbyid-nearMiss/${id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
